@if(!templateForPermitForm){
  <div class="card" *ngIf="contractor">
    <div class="card-body">
      <address>
        <!-- <h4>Selected Contractor</h4> -->
        <strong>{{ contractor.businessName }}</strong>
        <a
          class="pl-2"
          style="cursor: pointer;text-decoration: none;color:#009688;background-color: transparent"
          (click)="clearSelection()"
          *ngIf="showClear"
          >Clear</a
        ><br />
        {{ contractor.address?.address1 }}<br />
        {{ contractor.address?.address2
        }}<br *ngIf="contractor.address.address2" />
        {{ contractor.address?.city }}, {{ contractor.address?.state }}
        {{ contractor.address?.zip }}<br />
        <ng-container *ngIf="contractor.businessPhone?.number">
          <br />
          <abbr>Phone - </abbr>
          <span> {{ contractor.businessPhone?.number | phone }}</span>
        </ng-container>
        <ng-container *ngIf="contractor.contactFaxNumber?.number">
          <br />
  
          <abbr>Fax - </abbr>
          <span> {{ contractor.contactFaxNumber?.number | phone }}</span>
        </ng-container>
        <ng-container *ngIf="contractor.businessCell?.number">
          <br />
          <abbr>Cell - </abbr>
          <span> {{ contractor.businessCell?.number | phone }}</span>
        </ng-container>
      </address>
  
      <address *ngIf="contractor">
        <a href="mailto:#">{{ contractor.contactEmail?.email }}</a>
      </address>
    </div>
  </div>
  } 
  <!-- added by priya 07-01-2026 -->
  @else {
  <div class="card card-content" *ngIf="contractor" >
    <div class="card-body content" >
      <div class="content">
        <div class="header-data">
          <wm-common-text
            [data]="{ text: contractor.businessName, fontWeight: 'bold' }"
          ></wm-common-text>
          <wm-common-button
            *ngIf="showClear"
            class="clear-button"
            [data]="{text:'Clear',onClick: clearSelection.bind(this),}"
            >Clear</wm-common-button>
        </div>
        <wm-common-text
          [data]="{ text: contractor.address?.address1 }"
        ></wm-common-text>
        <wm-common-text
          [data]="{ text: contractor.address?.address2 }"
        ></wm-common-text>
        <div class="row-content">
          <wm-common-text
            [data]="{ text: contractor.address?.city }"
          ></wm-common-text>
          <wm-common-text
            [data]="{ text: contractor.address?.state }"
          ></wm-common-text>
          <wm-common-text
            [data]="{ text: contractor.address?.zip }"
          ></wm-common-text>
        </div>
        <ng-container *ngIf="contractor.businessPhone?.number">
          <div class="row-content">
            <wm-common-text [data]="{ text: 'Phone' }"></wm-common-text>
            <wm-common-text
              [data]="{ text: contractor.businessPhone?.number | phone }"
            ></wm-common-text>
          </div>
          <div class="row-content">
            <wm-common-text [data]="{ text: 'Fax' }"></wm-common-text>
  
            <wm-common-text
              [data]="{ text: contractor.contactFaxNumber?.number | phone }"
            ></wm-common-text>
          </div>
          <div class="row-content">
            <wm-common-text [data]="{ text: 'Cell' }"></wm-common-text>
            <wm-common-text
              [data]="{ text: contractor.businessCell?.number | phone }"
            ></wm-common-text>
          </div>
        </ng-container>
      </div>
  
      <address *ngIf="contractor">
        <a href="mailto:#" class="link-color">{{
          contractor.contactEmail?.email
        }}</a>
      </address>
    </div>
  </div>
  }
    <!-- end by priya 07-01-2026 -->
